import { useAppSignUpPageResultsUpdateEffect } from "@faire/retailer-visitor-shared/components/AppSignUp/AppSignUpPageResultsProvider";
import { LayoutElementBasedCarousel } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/LayoutElementBasedCarousel";
import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { useBestsellerProductsQuery } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/DataFetching/useBestsellerProductsQuery";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import * as React from "react";

import { ProductTileImpressionProvider } from "../../__internal__/ProductTileImpressionsProvider";

export const BestsellerProductsCarousel: React.FC = () => {
  const { bestsellerProductsElement, requestId, isFetching } =
    useBestsellerProductsQuery();

  const { isTablet } = useViewport();

  const headerRef = useDoActionWhenVisible(() =>
    trackLoggedOutRetailersLoggedOutHomeRedesignView(
      `bestseller_products_carousel-header`,
      "v2"
    )
  );

  useAppSignUpPageResultsUpdateEffect({
    productTiles: (bestsellerProductsElement?.layout_element_data ?? []).map(
      (data) => data.lean_product_with_brand_tile?.product
    ),
  });

  if (isFetching) {
    return (
      <div className="flex h-[400px] items-center justify-center lg:h-[429px] xl:h-[480px] 2xl:h-[578px]">
        <LoadingSpinner />
      </div>
    );
  }

  if (!bestsellerProductsElement || !requestId) {
    return null;
  }

  return (
    <SlideIn offset={getSpacing("3x")}>
      <div
        ref={headerRef}
        className="relative overflow-hidden p-8 px-0 md:p-8 lg:p-12"
      >
        <ProductTileImpressionProvider
          requestId={requestId}
          onClickEventName={bestsellerProductsElement.on_click_event_name}
        >
          <Typography
            variant={{
              mobileAndAbove: "pageHeaderSerifRegular",
              xLargeAndAbove: "displaySSerifRegular",
              xxLargeDesktop: "displayMSerifRegular",
            }}
            className="pl-4! md:pl-0!"
          >
            {bestsellerProductsElement.main_text}
          </Typography>
          <Spacer size="3x" />
          <LayoutElementBasedCarousel
            layoutElement={bestsellerProductsElement}
            requestId={requestId}
            itemsPerSlide={{
              mobileAndAbove: 2,
              tabletAndAbove: 4,
              desktopAndAbove: 5,
              xLargeAndAbove: 6,
            }}
            onItemClick={(_x, _y, productLink) => {
              trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick(
                "bestseller_products_carousel",
                productLink,
                "v2"
              );
            }}
            hideTitle
            arrowOffsetX={isTablet ? -8 : undefined}
            className="box-border"
          />
        </ProductTileImpressionProvider>
      </div>
    </SlideIn>
  );
};
